import React, {Fragment} from 'react';
import AttendanceContent from '../../components/account/AttendanceContent';

const Attendance = () => {
    return (
        <Fragment>       
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">출석</div>
                </div>
            </div>
            <AttendanceContent />
        </Fragment>
    );
};

export default Attendance;


// WEBPACK FOOTER //
// ./src/containers/Account/Attendance.js